// src/components/DeviceSettings.tsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import ReactDOM from "react-dom";
import '../App.css';
import DeviceGraphModal from "./DeviceGrahpModal";
import DeviceSetDrawer from './DeviceSettingDrawer'
import DeviceSetDrawerM from './DeviceSettingDrawerM'
import { useSocket } from "../context/SocketProvider";


import * as DeviceStyle from "../styles/DeviceSettings.style";
import * as GroupStyle from "../styles/GroupSettings.style";
import '../styles/DeviceInfo.css'; // 여기에 스타일 적용
import { MediaQuery } from 'react-responsive';

import DevicePageNextTabletIcon from '../imgs/ic_arrow_page_next.svg';
import DevicePagePreTabletIcon from '../imgs/ic_arrow_page_pre.svg';


//const SOCKET_URL = "http://172.16.20.112:3000"; // socket.io 서버
const SOCKET_URL = "https://rek-hybrid.co.kr"; // socket.io 서버

interface Device {
  [k: string]: any;
}

interface UserData {
    role: string;
    // 필요한 다른 속성들...
}

// 그래프 데이터용
interface TempData {
  time: string;
  value: number;
}
interface HumidData {
  time: string;
  value: number;
}

interface Props {
    // 유저 정보
    currentUser: UserData | null;
    // 디바이스 정보
    devices: Device[];

    // 페이지 인덱스
    currentIndex: number;
    setCurrentIndex: (v: number) => void;
    nextDevice: () => void;
    prevDevice: () => void;

    // site id, group id,name
    selectedSiteId: number | null;
    selectedGroupId: number | null;
    selectedGroupName: string | null;

    deviceSettingTab: number;
    setDeviceSettingTab: (n: number) => void;

    // 디바이스 탭 제어 1 탭 설정 값
    this_brightness: number;
    setThisBrightness: (v: number) => void;
    this_brightnessMode: number;
    setThisBrightnessMode: (v: number) => void;

    // 디바이스 탭 제어 2 탭 설정 값 없음

    // 디바이스 탭 제어 3 탭 설정 값
    this_distanceLeft: number;
    setThisDistanceLeft: (v: number) => void;
    this_distanceRight: number;
    setThisDistanceRight: (v: number) => void;
    this_distanceBottom: number;
    setThisDistanceBottom: (v: number) => void;

    // Tab 4
    led_mode: number;
    setLed_mode: (v: number) => void;
    maxBright: number;
    setMaxBright: (v: number) => void;
    minBright: number;
    setMinBright: (v: number) => void;
    keepOnTime: number;
    setKeepOnTime: (v: number) => void;
    sideOnLed: number;
    setSideOnLed: (v: number) => void;   

    tempData: TempData[];
    setTempData: React.Dispatch<React.SetStateAction<TempData[]>>;
    humidData: HumidData[];
    setHumidData: React.Dispatch<React.SetStateAction<HumidData[]>>;
    
}

const DeviceSettings: React.FC<Props> = ({
    currentUser,
    devices: socketDevices, // 부모로부터 오는 'Props' 이름을 변경
    currentIndex,
    setCurrentIndex,
    nextDevice,
    prevDevice,
    selectedSiteId,
    selectedGroupId,
    selectedGroupName,

    deviceSettingTab,
    setDeviceSettingTab,

    // 디바이스 탭 제어 1 탭 설정 값
    this_brightness,
    setThisBrightness,
    this_brightnessMode,
    setThisBrightnessMode,

    // 디바이스 탭 제어 2 탭 설정 값 없음

    // 디바이스 탭 제어 3 탭 설정 값
    this_distanceLeft,
    setThisDistanceLeft,
    this_distanceRight,
    setThisDistanceRight,
    this_distanceBottom,
    setThisDistanceBottom,    

    // Tab 4
    led_mode,
    setLed_mode,
    maxBright,
    setMaxBright,
    minBright,
    setMinBright,
    keepOnTime,
    setKeepOnTime,
    sideOnLed,
    setSideOnLed,      

    tempData,
    setTempData,
    humidData,
    setHumidData,
}) => {
    const socket = useSocket();

    const [currentIndexM, setCurrentIndexM] = useState(0);

    const [showConfigModal, setShowConfigModal] = useState(false);
    const [showGraphModal, setShowGraphModal] = useState(false);

    const deviceNum = currentIndex + 1;
    const [selectedDeviceNum, setSelectedDeviceNum] = useState(0);

    const [dailyData, setDailyData] = useState<any[]>([]);
    const [weeklyData, setWeeklyData] = useState<any[]>([]);

    const [viewMode, setViewMode] = useState('all'); // 'page' (크게 보기: 현재 방식), 'all' (한번에 보기: 스크롤)

    // ***************************************************************************
    //    DB 설정 값으로 고정 값 로딩
    // ***************************************************************************    
    const [devicesDB, setDevicesDB] = useState< any[]>([]);

    // 내부적으로 화면에 뿌려줄 '진짜' 상태
    const [displayDevices, setDisplayDevices] = useState<Device[]>([]);
    
    // 앱 활성화시 DB 데이터 불러오기
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                //console.log("📱 화면 활성화 감지: 최신 정보를 불러옵니다.");
                fetchDeviceGetStaticInfo();
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [selectedGroupId]); // 의존성 배열 확인

    // [로직 A] 부모(소켓)로부터 데이터가 들어오면 업데이트
    useEffect(() => {
        if (socketDevices && socketDevices.length > 0) {
            setDisplayDevices(socketDevices);
        }
    }, [socketDevices]);

    // [로직 B] DB에서 데이터를 새로 불러오면 업데이트
    const fetchDeviceGetStaticInfo = async () => {
        if (!selectedSiteId || !selectedGroupId) return;
        try {
            const response = await axios.get(`${SOCKET_URL}/api/device/info`, {
            params: { selectedSiteId, selectedGroupId },
            });

            if(response.data === null || response.data === '')
            {
                console.log('[DEBUG] React: 조회 값 없음');
            }
            else
            {
                const dbData = response.data.data; // 서버에서 변환해서 보내준 transformedData 배열

                setDevicesDB(dbData);   // 정적 정보(DB 원본 데이터용) 업데이트
                setDisplayDevices(dbData);  // 화면 상태를 DB 값으로 강제 업데이트

                console.log('[DEBUG] React: DB 데이터로 실시간 상태 동기화 완료');
            }
        } catch (error) {
            console.error('[DEBUG] React: API 호출 실패', error);
        }
    };    
  
    // ***************************************************************************
    //    Mode 1일 때 개별 on,off time 값 로딩
    // ***************************************************************************    
    const [getGroupMode, setGetGroupMode] = useState(0);
    const [ledModeList, setledModeList] = useState<string[]>([]);
    const [onTList, setOnTList] = useState<string[]>([]);
    const [offTList, setOffTList] = useState<string[]>([]);

    /**
     * minutes (0~1439) → "HH:MM AM/PM"
     */
    function minutesToHHMM(minutes: number) {
        const h24 = Math.floor(minutes / 60);
        const m = minutes % 60;

        const period = h24 >= 12 ? "PM" : "AM";
        let h12 = h24 % 12;
        if (h12 === 0) h12 = 12;

        // return `${String(h12).padStart(2, "0")}:${String(m).padStart(2, "0")} ${period}`;
        return `${String(h24).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
    }

    const fetchDeviceGetStaticModeInfo = async () => {
        if (!selectedSiteId || !selectedGroupId) return;
        try {
            const response = await axios.get(`${SOCKET_URL}/api/device/getmodeinfo`, {
            params: { selectedSiteId, selectedGroupId },
            });

        // 서버에서 { data: [ { ... } ] } 또는 { data: [] } 형태로 옵니다.
        const resultList = response.data.data;
        // const resultList:DeviceSensorInfo[] = response.data.data;

        if (!resultList || resultList.length === 0) {
            console.log('[DEBUG] React: 조회 값 없음');
        } else {
            //console.log('[DEBUG] React: 조회 응답', response.data);
            
            // 💡 핵심: 배열의 0번째 요소에서 led_mode를 가져옵니다.
            const ledModeValue = resultList[0].led_mode;
            setGetGroupMode(ledModeValue);
            const ledModesNumbers = resultList.map((item: any) => item.led_mode);
            // console.log('[DEBUG] 추출된 LED Mode 배열:', ledModesNumbers);

            // 2. 💡 OnT와 OffT를 배열로 추출
            // resultList의 모든 요소에서 OnT와 OffT만 뽑아 새 배열을 만듭니다.
            const onTsNumbers = resultList.map((item: any) => item.OnT);
            const offTsNumbers = resultList.map((item: any) => item.OffT);
            // const onTs = resultList.map((item: DeviceSensorInfo) => item.OnT);
            // const offTs = resultList.map((item: DeviceSensorInfo) => item.OffT);
            // 2. 숫자를 HH:MM 문자열 배열로 변환
            // 1. 숫자로 뽑아낸 경우 (onTsNumbers가 number[] 인 경우)
            const onTsStrings = onTsNumbers.map((num: number) => minutesToHHMM(num));
            const offTsStrings = offTsNumbers.map((num: number) => minutesToHHMM(num));
            // console.log('[DEBUG] 추출된 OnT 배열:', onTsNumbers); // [값1, 값2, ...]
            // console.log('[DEBUG] 추출된 OffT 배열:', offTsNumbers);

            // 3. 상태 업데이트
            setOnTList(onTsStrings);
            setOffTList(offTsStrings);
            setledModeList(ledModesNumbers);
        }
        } catch (error) {
            console.error('[DEBUG] React: API 호출 실패', error);
        }
    };

    const loadData = async () => {
        fetchDeviceGetStaticInfo();
        fetchDeviceGetStaticModeInfo();        
        //console.log("데이터를 불러옵니다...");
    }; 

    // 2. 탭 진입 시 (groupSettingTab이 변경될 때) 데이터 로드 (추가/수정)
    useEffect(() => {
        // 예를 들어, 해당 설정 탭이 '1'번 탭이라고 가정합니다.
        // if (groupSettingTab === 1) { // 특정 탭에 한정하고 싶다면 이 조건문을 사용합니다.
            loadData();
            // fetchDeviceGetStaticInfo();
            // fetchDeviceGetStaticModeInfo();
            //console.log('=>',selectedGroupName);
        // }
    // 탭 상태와 API 호출에 필요한 의존성을 포함합니다.
    }, [deviceSettingTab, selectedSiteId, selectedGroupId]);

    // 3. devicesDB 데이터가 로드되면 개별 상태 변수 초기화 (추가)
    useEffect(() => {
        if (devicesDB && devicesDB.length > 0) {
            const initialData = devicesDB[0]; // 배열의 첫 번째 장치 객체 (단일 설정 객체)
            getMonthData();

            //console.log('[DEBUG] React: 개별 상태 변수 초기화 완료', initialData);
        }
    }, [devicesDB]); // devicesDB가 변경될 때마다 실행


    // ***************************************************************************
    //    DB 설정 값으로 월별 켜는시간, 끄는시간 고정 값 로딩
    // ***************************************************************************       
    const [monthOnTime, setMonthOnTime] = useState<string>("-");
    const [monthOffTime, setMonthOffTime] = useState<string>("-");

    // 켜는 시간, 끄는 시간 계산
    function findMaxGapTimes(monthData: {time: string; value: number}[]) {
        if (monthData.length < 2) return null;

        // 문자열 분 → 숫자 분
        const minutesArr = monthData.map(item => Number(item.time));

        // 오름차순 정렬
        minutesArr.sort((a, b) => a - b);

        let maxGap = -1;
        let start = 0, end = 0;

        for (let i = 0; i < minutesArr.length - 1; i++) {
            const gap = minutesArr[i + 1] - minutesArr[i];
            if (gap > maxGap) {
                maxGap = gap;
                start = minutesArr[i];
                end = minutesArr[i + 1];
            }
        }

        // 24시간 순환 간격 고려
        const wrapGap = 24 * 60 - (minutesArr[minutesArr.length - 1] - minutesArr[0]);
        if (wrapGap > maxGap) {
            maxGap = wrapGap;
            start = minutesArr[minutesArr.length - 1];
            end = minutesArr[0];
        }

        // 분 → HH:MM
        function minutesToHHMMSimple(min: number) {
            const h = Math.floor(min / 60) % 24;
            const m = min % 60;
            return `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}`;
        }

        return {
            start: minutesToHHMMSimple(start) || "00:00",
            end: minutesToHHMMSimple(end) || "00:00",
            gap: maxGap
        };
    }
 

    // DB minutes 배열 → UI용 객체 배열
    function convertDBMonthDataToUI(dbData: any) {
        const uiMonthData: {time: string; value: number}[][] = [];

        for (let i = 1; i <= 12; i++) {
            const monthKey = `${i}M`;
            const raw = dbData[monthKey];

            if (!raw || !Array.isArray(raw)) {
            uiMonthData.push([]); // 데이터 없으면 빈 배열
            continue;
            }

            const formatted = raw.map(([minutes, bright]: [number, number]) => ({
            time: String(minutes),
            value: bright,
            }));

            uiMonthData.push(formatted);
        }

        return uiMonthData;
    }

    const today = new Date();
    const currentMonthIndex = today.getMonth();
        
    const getMonthData = async () => {
        if (!selectedSiteId || !selectedGroupId) return;

        try {
                const res = await axios.get(`${SOCKET_URL}/api/month/get`, {
                params: { site_id: selectedSiteId, group_id: selectedGroupId },
            });

            if (res.data) {
                const uiData = convertDBMonthDataToUI(res.data);
                const marchMaxGap = findMaxGapTimes(uiData[currentMonthIndex]); // 0-index 기준, 3월 = index 2
                //console.log("월별 설정 조회:", uiData);
                //console.log("켜짐꺼짐: ",currentMonthIndex);
                if (marchMaxGap) {
                    setMonthOnTime(marchMaxGap.end);
                    setMonthOffTime(marchMaxGap.start);
                }
                //console.log("켜짐꺼짐: ",monthOnTime,monthOffTime);
            }

        } catch (err) {
            console.error("월별 설정 조회 오류:", err);
        }
    };


    // ***************************************************************************
    // ***************************************************************************
    // ***************************************************************************    

    // 디바이스 번호를 받고 모달을 여는 함수 (필수)
    const openConfigModal = (dNum:number) => {
        setSelectedDeviceNum(dNum); // 디바이스 번호 저장
        setShowConfigModal(true);      // 모달 열기
    };    
    const closeModal = () => setShowConfigModal(false);

    const formatpaddedId = (num: number, targetLength: number): string => {
        // 1. 숫자를 문자열로 변환합니다.
        const str = String(num);
        // 2. padStart() 메서드를 사용하여 문자열의 시작 부분을 '0'으로 채웁니다.
        return str.padStart(targetLength, '0');
    }	

    // 개별 디바이스 제어 설정 값
    const handleApply_DeviceSets = (tabNumber: number, deviceNumber: number) => {
        if (!socket || !selectedSiteId || !selectedGroupId) return;

        const sid: string = formatpaddedId(selectedSiteId,4);
        const gid: string = formatpaddedId(selectedGroupId,3);

        let payload: any = { socketId:socket.id , siteId: sid, groupId: gid };
        // let payload: any = { siteId: selectedSiteId, groupId: selectedGroupId };

        switch (deviceSettingTab) {
            case 1:
            let LEDSts = this_brightness;
            let LEDTst = this_brightnessMode;
            payload = {
                ...payload,
                tabNumber,
                deviceNumber,
                LEDSts,
                LEDTst, // 라디오 선택지 값 포함
            };
            break;
            case 2:
                payload = {
                    ...payload,
                    tabNumber,
                    deviceNumber,
                };
            break;
            case 3:
                let LDistS = this_distanceLeft;
                let RDistS = this_distanceRight;
                let DDistS = this_distanceBottom;
                payload = {
                    ...payload,
                    tabNumber,
                    deviceNumber,
                    LDistS,
                    RDistS,
                    DDistS,
                };
            break;
        }
        socket.emit('device_publish', payload);
        closeModal();
        // alert(`전송 데이터: ${JSON.stringify(payload, null, 2)}`);
    };

    // 그룹 디바이스 정보 요청에 대한 pub
    const handleApply_Gets = () => {
        if (!socket || !selectedSiteId || !selectedGroupId) return;

        const sid: string = formatpaddedId(selectedSiteId,4);
        const gid: string = formatpaddedId(selectedGroupId,3);

        let payload: any = { socketId:socket.id , siteId: sid, groupId: gid };
        let req: any = 2;
        // let payload: any = { siteId: selectedSiteId, groupId: selectedGroupId };

        payload = {
            ...payload,
            req,
        };

        socket.emit('get_publish', payload);
        //alert(`전송 데이터: ${JSON.stringify(payload, null, 2)}`);
    };

    const openGraphModal = () => {
        setShowGraphModal(true);
    };

    // 일일 그래프 데이터
    const fetchDailyData = async (deviceId: number) => {
        if (!selectedSiteId || !selectedGroupId) return;
        try {
            const res = await axios.get(`${SOCKET_URL}/api/graph/daily`, {
                params: { selectedSiteId, selectedGroupId, deviceId },
            });
            setDailyData(res.data);
            //setShowGraphModal(true); // 데이터 가져오면 모달 열기
            //console.log('일일 데이터 ',res.data);

        } catch (err) {
            console.error('Error fetching DailyData data:', err);
        }
    };   
    
    // 7일 그래프 데이터
    const fetchWeeklyData = async (deviceId: number) => {
        if (!selectedSiteId || !selectedGroupId) return;
        try {
            const res = await axios.get(`${SOCKET_URL}/api/graph/weekly`, {
                params: { selectedSiteId, selectedGroupId, deviceId },
            });
            setWeeklyData(res.data);
            //setShowGraphModal(true); // 데이터 가져오면 모달 열기
            //console.log('7일 데이터 ',res.data);

        } catch (err) {
            console.error('Error fetching DailyData data:', err);
        }
    };   
    
    // 온도 그래프 데이터 테스트
    const fetchTempData = async (deviceId: number) => {
        if (!selectedSiteId || !selectedGroupId) return;
        try {
            const res = await axios.get(`${SOCKET_URL}/api/device/temp`, {
                params: { selectedSiteId, selectedGroupId, deviceId },
            });
            setTempData(res.data);
            setShowGraphModal(true); // 데이터 가져오면 모달 열기

        } catch (err) {
            console.error('Error fetching temperature data:', err);
        }
    };
    // 습도 그래프 데이터 테스트
    const fetchHumidData = async (deviceId: number) => {
        if (!selectedSiteId || !selectedGroupId) return;
        try {
            const res = await axios.get(`${SOCKET_URL}/api/device/humid`, {
                params: { selectedSiteId, selectedGroupId, deviceId },
            });
            setHumidData(res.data);
            setShowGraphModal(true); // 데이터 가져오면 모달 열기

        } catch (err) {
            console.error('Error fetching temperature data:', err);
        }
    };

    const getGraphDatas = async (deviceId: number) => {
        setSelectedDeviceNum(deviceId); // 디바이스 번호 저장
        fetchDailyData(deviceId);
        fetchWeeklyData(deviceId);
        setShowGraphModal(true);
    };

    if (displayDevices.length === 0) {
        return <p className="text-center text-gray-500">수신된 디바이스 데이터 없음</p>;
    }


    // ***************************************************************************
    // ***************************************************************************
    // ***************************************************************************   
    // 태블릿 전용 페이징

    // 한 페이지에 보여줄 디바이스 수
    const DEVICES_ON_SCREEN = 3;

    // 총 디바이스 개수가 총 페이지 번호 개수
    const totalDeviceCount = displayDevices.length;

    // 디바이스 개수가 화면 표시 개수보다 적거나 같은 경우
    const isSmallSet = totalDeviceCount <= DEVICES_ON_SCREEN;    

    // 최대 허용 시작 인덱스 (마지막 3개 그룹의 시작 인덱스, 예: 20개일 때 17)
    const maxStartIndex = totalDeviceCount > DEVICES_ON_SCREEN 
        ? totalDeviceCount - DEVICES_ON_SCREEN 
        : 0;
    
    // 화면에 표시할 디바이스의 '실제' 시작 인덱스 결정
    // 상위 컴포넌트에서 이미 조정되었지만, 혹시 모를 경우를 대비해 경계 조건을 한 번 더 확인
    const displayStartIndex = isSmallSet 
        ? 0 
        : Math.min(currentIndex, maxStartIndex);

    // 총 페이지 수 (사용자 표기용)
    const totalPages = Math.ceil(totalDeviceCount / DEVICES_ON_SCREEN);
    // 현재 페이지 (1부터 시작, 0, 3, 6... 인덱스를 1, 2, 3... 페이지로 변환)
    const currentPage = Math.floor(displayStartIndex / DEVICES_ON_SCREEN) + 1;

    // 현재 화면에 표시할 3개의 디바이스 목록 계산
    const currentDevices = displayDevices.slice(displayStartIndex, displayStartIndex + DEVICES_ON_SCREEN);

    // 현재 페이지 그룹에 해당하는 디바이스 목록 계산
    const startIndex = currentIndex;

    //////////////////////////////////////////////////
    // 모바일 전용 페이징

    // 한 페이지에 보여줄 디바이스 수
    const MOBILE_DEVICES_ON_SCREEN = 1;

    // 디바이스 개수가 화면 표시 개수보다 적거나 같은 경우
    const mobile_isSmallSet = totalDeviceCount <= MOBILE_DEVICES_ON_SCREEN;    

    // 최대 허용 시작 인덱스 (마지막 3개 그룹의 시작 인덱스, 예: 20개일 때 17)
    const mobile_maxStartIndex = totalDeviceCount > MOBILE_DEVICES_ON_SCREEN 
        ? totalDeviceCount - MOBILE_DEVICES_ON_SCREEN 
        : 0;

    // 화면에 표시할 디바이스의 '실제' 시작 인덱스 결정
    // 상위 컴포넌트에서 이미 조정되었지만, 혹시 모를 경우를 대비해 경계 조건을 한 번 더 확인
    const mobile_displayStartIndex = mobile_isSmallSet 
        ? 0 
        : Math.min(currentIndexM, mobile_maxStartIndex);

    // 현재 화면에 표시할 3개의 디바이스 목록 계산
    const mobile_currentDevices = displayDevices.slice(mobile_displayStartIndex, mobile_displayStartIndex + MOBILE_DEVICES_ON_SCREEN);

    // 현재 페이지 그룹에 해당하는 디바이스 목록 계산
    const startIndexM = currentIndexM;

    const nextDeviceM = () => {
        // 1. currentIndex를 1 증가
        let newIndex = currentIndexM + MOBILE_DEVICES_ON_SCREEN;

        // 2. 최대 허용 시작 인덱스를 넘어서면, 그 값으로 고정
        if (newIndex > mobile_maxStartIndex) {
            newIndex = mobile_maxStartIndex;
        }
        
        // 3. 업데이트
        if (currentIndexM < mobile_maxStartIndex) { // 마지막 그룹 시작 전까지만 실제로 1씩 이동
            setCurrentIndexM(newIndex);
        }
        // currentIndex가 이미 maxStartIndex인 경우, nextDevice를 눌러도 이동하지 않음 (버튼이 disabled될 것임)
    };

    const prevDeviceM = () => {
        // 1. currentIndex를 1 감소
        let newIndex = currentIndexM - MOBILE_DEVICES_ON_SCREEN;

        // 2. 0보다 작으면 0으로 고정
        if (newIndex < 0) {
            newIndex = 0;
        }
        
        // 3. 업데이트
        setCurrentIndexM(newIndex);
    };

    // ***************************************************************************
    // ***************************************************************************
    // ***************************************************************************   

    // 뷰 모드 전환 함수
    const toggleViewMode = () => {
        setViewMode(prevMode => (prevMode === 'page' ? 'all' : 'page'));
    };


    // 1. Props의 타입을 정의하는 인터페이스 생성
    interface InfoCardProps {
        title: string;       // 제목은 문자열
        value: number | string; // 값은 숫자 또는 문자열
        unit?: string;       // 단위는 선택적(optional) 문자열
        className?: string;  // 클래스 이름은 선택적(optional) 문자열
    }

    // 2. InfoCard 컴포넌트에 정의된 타입을 적용 (함수형 컴포넌트에 Generic 사용)
    const InfoCard = ({ title, value, unit, className = '' }: InfoCardProps) => (
        <div className={`info-card ${className}`}>
            <p className="card-title">{title}</p>
            <div className="card-value-container">
                <span className="card-value">{value}</span>
                {unit && <span className="card-unit">{unit}</span>}
            </div>
        </div>
    );


    // 1. DevicesDB에서 가져오는 설정 정보의 타입 정의
    interface DeviceDBInfo {
        fwVer: string | null | undefined;
        minLED: number | null | undefined;
        maxLED: number | null | undefined;
        loc: string | null | undefined; // 위도
        lot: string | null | undefined; // 경도
        monthOnTime?: number | null | undefined; // 켜는 시간 (분)
        monthOffTime?: number | null | undefined; // 끄는 시간 (분)
        // ... devicesDB의 다른 속성들
        [k: string]: any;
    }

    // 2. Device 실시간 정보의 타입 정의
    interface DeviceData {
        deviceNum: number; 
        errSts: string | number | null | undefined; // API 응답에 따라 string 또는 number일 수 있음
        curT: string | null | undefined; 
        batSts: number | string | null | undefined;
        batV: number | string | null | undefined; 
        LEDSts: number | string | null | undefined; 
        wPwr: number | string | null | undefined;
        wGen: number | string | null | undefined;
        sPwr: number | string | null | undefined;
        sGen: number | string | null | undefined;
        LEDCP: number | string | null | undefined;
        LEDPwr: number | string | null | undefined;
        temp: number | string | null | undefined;
        hum: number | string | null | undefined;       
        // ... Device에 있는 다른 모든 속성들
        [k: string]: any;
    }
    
    interface SimpleDeviceInfoProps {
        device: DeviceData; // 위에서 정의한 DeviceData 타입 사용
        fullIndex: number;
        deviceNum: number;
        selectedGroupName: string | null | undefined;
        devicesDB: DeviceDBInfo[]; // DeviceDBInfo 배열 타입 사용
        // 추가적인 prop이 있다면 여기에 정의
    }

    const SimpleDeviceInfo: React.FC<SimpleDeviceInfoProps> = ({ 
        device, 
        fullIndex, 
        deviceNum, 
        selectedGroupName, 
        devicesDB 
    }) => {
        const dbInfo = devicesDB[fullIndex] || {};
        const errorStatusText = Number(device.errSts) > 0 ? '에러 발생' : '정상 작동';

        return (
            // <center>
            <div className="simple-device-info">
                    <h3 style={{ borderBottom: '1px dashed #ccc', paddingBottom: '15px', marginBottom: '15px' }}>
                        {selectedGroupName} {deviceNum}
                        <p></p>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px' }}>
                            <DeviceStyle.GraphButton
                                onClick={() => getGraphDatas(deviceNum)}
                            >
                                그래프
                            </DeviceStyle.GraphButton>  
                            <DeviceStyle.DeviceButton
                                onClick={() => openConfigModal(deviceNum)}
                            >
                                제어/설정
                            </DeviceStyle.DeviceButton>
                        </div>
                    </h3>
                

                {/* <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px' }}> */}
                <div style={{gridTemplateColumns: '1fr 1fr', gap: '5px', fontSize: '12px' }}>
                    {/* 1. 상태 */}                    
                    <p  className="line-patch">⚡ 상태: <span className="status-text">{errorStatusText} </span> (Code: {Number(device.errSts)})</p> 
                    {/* <p>🕒 시간: {device.curT ?? '-'} &nbsp;&nbsp;&nbsp; 💾 F/W 버전: {dbInfo.fwVer || '-'}</p> */}
                    <p className="line-patch">🕒 시간: {device.curT ?? '-'} </p>
                    {/* <p>💾 F/W 버전: {dbInfo.fwVer || '-'}</p> */}
                    {/* <p>🔋 배터리: {device.batSts ?? '-'}% &nbsp;&nbsp;&nbsp;&nbsp; 💡 LED 밝기: {device.LEDSts ?? '-'}%</p> */}
                    <p className="line-patch">🔋 배터리: {device.batSts ?? '-'}% ({device.batV ?? '-'}mV)</p>
                    <p className="line-patch">💡 LED 밝기: {device.LEDSts ?? '-'}%</p>
                    
                    {/* 2. 에너지 */}
                    {/* <p>💨 풍력 순간 발전: {device.wPwr ?? '-'} mW &nbsp;|&nbsp; 누적 발전: {device.wGen ?? '-'} Wh</p> */}
                    <p className="line-patch">💨 풍력 순간 발전: {device.wPwr ?? '-'} mW </p>
                    <p className="line-patch">💨 풍력 누적 발전: {device.wGen ?? '-'} Wh</p>
                    {/* <p>☀️ 태양광 순간 발전: {device.sPwr ?? '-'} mW &nbsp;|&nbsp; 누적 발전: {device.sGen ?? '-'} Wh</p> */}
                    <p className="line-patch">☀️ 태양광 순간 발전: {device.sPwr ?? '-'} mW </p>
                    <p className="line-patch">☀️ 태양광 누적 발전: {device.sGen ?? '-'} Wh</p>
                    {/* <p>📉 LED 순간 소모: {device.LEDCP ?? '-'} mW &nbsp;|&nbsp; 누적 소모: {device.LEDPwr ?? '-'} Wh</p> */}
                    <p className="line-patch">📉 LED 순간 소모: {device.LEDCP ?? '-'} mW</p>
                    <p className="line-patch">📈 LED 누적 소모: {device.LEDPwr ?? '-'} Wh</p>

                    {/* 3. 환경 및 설정 */}
                    <p className="line-patch">🌡️ 온도: {device.temp ?? '-'} °C &nbsp;&nbsp;&nbsp; 💧 습도: {device.hum ?? '-'} %</p>
                    {/* <p>💧 습도: {device.hum ?? '-'} %</p> */}

                    {/* 조건부 렌더링 적용 부분 */}
                    {/* {getGroupMode === 1 ? ( */}
                    {Number(ledModeList[deviceNum - 1]) === 1 ? (
                        // getGroupMode가 1일 때 표시되는 UI
                        <>
                            <p className="line-patch">
                                ⬆️ 켜는 시간: {monthOnTime || '-'}
                            </p>
                            <p className="line-patch">
                                ⬇️ 끄는 시간: {monthOffTime || '-'}
                            </p>
                        </>
                    ) : (
                        // 그 외의 경우(1이 아닐 때) 표시되는 UI
                        <>
                            <p className="line-patch">
                                ⏱️ 켜는 시간: {onTList[deviceNum - 1] ?? '-'}
                            </p>
                            <p className="line-patch">
                                ⏱️ 끄는 시간: {offTList[deviceNum - 1] ?? '-'}
                            </p>                            
                        </>
                    )}
                    {/* <p className="line-patch">⬆️ 켜는 시간: {monthOnTime || '-'} &nbsp;&nbsp;&nbsp; ⬇️ 끄는 시간: {monthOffTime || '-'}</p> */}
                    {/* <p>⬇️ 끄는 시간: {monthOffTime || '-'}</p> */}
                    <p className="line-patch">⏱️ 센싱 횟수(24시간): {device.sNum ?? '0'} </p>

                    {/* 4. 위치/버전 */}
                    <p className="line-patch">📍 위도/경도: {dbInfo.loc || '-'} / {dbInfo.lot || '-'}</p>
                    <p className="line-patch">📍 기울기 좌(+)우(-): {dbInfo.vecx || '0'}</p>
                    <p className="line-patch">📍 기울기 상(+)하(-): {dbInfo.vecy || '0'}</p>
                    <p className="line-patch">💾 F/W 버전: {dbInfo.fwVer || '-'}</p>
                </div>
                
            </div>
            // </center>
        );
    };


    return (
        <>
        <MediaQuery maxWidth={767}> 

            <DeviceStyle.MainContainer>

                <DeviceGraphModal
                    show={showGraphModal}
                    onClose={() => setShowGraphModal(false)}
                    selectedGroupName={selectedGroupName}
                    deviceNum={selectedDeviceNum}
                    dailyData={dailyData}
                    weeklyData={weeklyData}
                />

                {/* 💡 뷰 모드 전환 버튼 추가 */}
                <div style={{ textAlign: 'right', marginBottom: '15px' }}>
                    <button className="btn btn-secondary" onClick={toggleViewMode} style={{ padding: '8px 15px', cursor: 'pointer', border: '1px solid #ccc', borderRadius: '5px' }}>
                        {viewMode === 'page' ? '한 번에 보기 (스크롤)' : '크게 보기 (페이지)'}
                    </button>
                </div>
                <div style={{ textAlign: 'right', marginBottom: '15px' }}>
                    <button className="btn btn-secondary" onClick={loadData} style={{ padding: '8px 15px', cursor: 'pointer', border: '1px solid #ccc', borderRadius: '5px' }}>
                        새로고침
                    </button>
                </div>
                
                {/* 페이징 버튼 조건부 렌더링 */}
                {viewMode === 'page' && (

                    <DeviceStyle.DevicePageFrame>
                        
                        {/* 현재 인덱스가 0일 때 이전 버튼 비활성화 */}
                        <DeviceStyle.DevicePageButton
                            onClick={prevDeviceM} 
                            disabled={mobile_displayStartIndex === 0}
                        >
                            {/* <DeviceStyle.DevicePageIcon
                                $imgUrl={DevicePagePreTabletIcon}
                            /> */}
                            &lt; 이전
                        </DeviceStyle.DevicePageButton>
                        
                        <DeviceStyle.DevicePageNumTextFrame>
                        <DeviceStyle.DevicePageNumText>
                            {/* 현재 화면에 보이는 디바이스 범위 */}
                            {totalDeviceCount > 0 ? (
                                <>
                                    {mobile_displayStartIndex + 1} / {totalDeviceCount}
                                    {/* {mobile_displayStartIndex + 1} - {Math.min(mobile_displayStartIndex + MOBILE_DEVICES_ON_SCREEN, totalDeviceCount)}  */}
                                    {/* <br></br>  */}
                                    {/* Total : {totalDeviceCount} */}
                                </>
                            ) : (
                                "디바이스 없음"
                            )}
                        </DeviceStyle.DevicePageNumText>
                        </DeviceStyle.DevicePageNumTextFrame>
                        
                        {/* 현재 인덱스가 마지막 3개 그룹의 시작점일 때 다음 버튼 비활성화 */}
                        <DeviceStyle.DevicePageButton
                            onClick={nextDeviceM} 
                            disabled={
                                displayDevices.length === 0 || 
                                mobile_displayStartIndex >= mobile_maxStartIndex
                            }
                        >
                            다음 &gt;
                            {/* <DeviceStyle.DevicePageIcon
                                $imgUrl={DevicePageNextTabletIcon}
                            />                             */}
                        </DeviceStyle.DevicePageButton>

                    </DeviceStyle.DevicePageFrame>          
                )}

                {viewMode === 'all' && (

                    <DeviceStyle.DevicePageFrame>
                        
                        <DeviceStyle.DevicePageNumTextFrame>
                        <DeviceStyle.DevicePageNumText>
                            {totalDeviceCount > 0 ? (
                                <>
                                    Total : {totalDeviceCount}
                                </>
                            ) : (
                                "디바이스 없음"
                            )}
                        </DeviceStyle.DevicePageNumText>
                        </DeviceStyle.DevicePageNumTextFrame>

                    </DeviceStyle.DevicePageFrame>          
                )}

                {/* 뷰 모드에 따른 렌더링 분기 */}
                {viewMode === 'page' ? (
                    // **********************************
                    // 🚀 크게 보기 (기존 페이징 방식) 렌더링
                    // **********************************

                    mobile_currentDevices.map((device, index) => {
                    // 현재 3개 중 몇 번째 디바이스인지 계산 (전체 devices 기준 index)
                        const fullIndex = startIndexM + index; 
                        
                        // 디바이스 번호 (1부터 시작)
                        const deviceNum = fullIndex + 1;

                        const errorStatusClass = Number(device.errSts) > 0 ? 'status-error' : 'status-ok';
                        const errorStatusText = Number(device.errSts) > 0 ? '에러 발생' : '정상 작동';                        
    
                        // devices 배열에서 해당 인덱스의 디바이스가 실제로 존재하는지 확인 (마지막 페이지에서 3개 미만일 수 있음)
                        if (!device) return null; 
    
                        return (
                                <div className="dashboard-mobile-container" key={device.deviceNum}>
                                    <DeviceStyle.DeviceTitle>
        
                                        <DeviceStyle.DeviceTitleText style={{color:'white'}}>
                                            {selectedGroupName} {deviceNum}
                                        </DeviceStyle.DeviceTitleText>
        
                                    </DeviceStyle.DeviceTitle>
                                    <DeviceStyle.DeviceTitle>
        
                                        <DeviceStyle.GraphButton
                                            onClick={() => getGraphDatas(deviceNum)}
                                        >
                                            그래프
                                        </DeviceStyle.GraphButton>                                    
                                        <DeviceStyle.DeviceButton
                                            onClick={() => openConfigModal(deviceNum)}
                                        >
                                            제어/설정
                                        </DeviceStyle.DeviceButton>
        
                                    </DeviceStyle.DeviceTitle>

                                    <br></br>

                                    {/* 1. 헤더: 핵심 상태 요약 및 시간 정보 */}
                                    <header className="dashboard-header">
    
                                        <div className={`system-status ${errorStatusClass}`}>
                                            <span className="status-dot"></span>
                                            <span className="status-text">{errorStatusText} 
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                <br></br>(Code: {Number(device.errSts) ?? '-'})</span>
                                        </div>
                                        <div className="time-info">
                                            <p>🕒 {device.curT}</p>
                                            <p>F/W 버전: {devicesDB[fullIndex] ? devicesDB[fullIndex].fwVer : '-'}</p>
                                        </div>
                                    </header>
    
                                    {/* 2. 메인 그리드: 중요 정보 (발전, 배터리, 환경) */}
                                    <div className="main-grid">
    
                                        {/* 2-1. 발전량 섹션 (2x2 그리드) */}
                                        <section className="section-panel power-generation-section">
                                            <h2 className="panel-title">⚡ 에너지 정보</h2>
                                            <div className="data-grid two-by-two">
                                                <InfoCard title="풍력 순간 발전" value={device.wPwr ?? '-'} unit="mW" className="highlight-card wind" />
                                                <InfoCard title="풍력 누적 발전" value={device.wGen ?? '-'} unit="Wh" className="highlight-card wind" />
                                                <InfoCard title="태양광 순간 발전" value={device.sPwr ?? '-'} unit="mW" className="highlight-card solar" />
                                                <InfoCard title="태양광 누적 발전" value={device.sGen ?? '-'} unit="Wh" className="highlight-card solar" />
                                                <InfoCard title="LED 순간 소모" value={device.LEDCP ?? '-'} unit="mW" className="highlight-card led" />
                                                <InfoCard title="LED 누적 소모" value={device.LEDPwr ?? '-'} unit="Wh" className="highlight-card led" />                                                
                                            </div>
                                        </section>
    
                                        {/* 2-2. 배터리 상태 섹션 */}
                                        <section className="section-panel battery-section">
                                            <h2 className="panel-title">🔋 배터리 상태</h2>
                                            <div className="battery-display">
                                                <div className="large-value-display">
                                                    <span className="battery-percent">{device.batSts ?? '-'}</span>
                                                    <span className="percent-unit">%</span>
                                                </div>
                                                {/* CSS로 잔량에 따른 색상 변화 및 진행률 바 구현 */}
                                                <div className="progress-bar-container">
                                                    <div 
                                                        className="battery-progress-bar" 
                                                        style={{ width: `${device.batSts ?? 0}%` }}
                                                    ></div>
                                                </div>
                                                <p className="voltage-info">전압: {device.batV ?? '-'} mV</p>
                                            </div>
                                        </section>
    
                                        {/* 2-3. LED 상태 섹션 */}
                                        <section className="section-panel battery-section">
                                            <h2 className="panel-title">💡 LED 상태</h2>
                                            <div className="battery-display">
                                                <div className="large-value-display">
                                                    <span className="led-percent">{device.LEDSts ?? '-'}</span>
                                                    <span className="percent-unit">%</span>
                                                </div>
                                                {/* CSS로 잔량에 따른 색상 변화 및 진행률 바 구현 */}
                                                <div className="progress-bar-container">
                                                    <div 
                                                        className="led-progress-bar" 
                                                        style={{ width: `${device.LEDSts ?? 0}%` }}
                                                    ></div>
                                                </div>
                                                <p className="voltage-info">최소 / 최대 밝기: {devicesDB[fullIndex] ? devicesDB[fullIndex].minLED : '-'} / {devicesDB[fullIndex] ? devicesDB[fullIndex].maxLED : '-'}</p>
                                            </div>
                                        </section>
    
                                        {/* 2-4. 환경 및 설정 섹션 (2x2 그리드) */}
                                        <section className="section-panel environment-section">
                                            <h2 className="panel-title">🗺️ 환경 및 설정</h2>
                                            <div className="data-grid two-by-two">
                                                <InfoCard title="온도" value={device.temp ?? '-'} unit="°C" className="env-card" />
                                                <InfoCard title="습도" value={device.hum ?? '-'} unit="%" className="env-card" />
                                                {/* 조건부 렌더링 적용 부분 */}
                                                {Number(ledModeList[deviceNum - 1]) === 1 ? (
                                                    // getGroupMode가 1일 때 표시되는 UI
                                                    <>
                                                        <InfoCard title="켜는 시간" value={monthOnTime || '-'} unit="" />
                                                        <InfoCard title="끄는 시간" value={monthOffTime || '-'} unit="" />
                                                    </>
                                                ) : (
                                                    // 그 외의 경우(1이 아닐 때) 표시되는 UI
                                                    <>
                                                        <InfoCard title="⏱️켜는 시간" value={onTList[deviceNum - 1] || '-'} unit="" />
                                                        <InfoCard title="⏱️끄는 시간" value={offTList[deviceNum - 1] || '-'} unit="" />                                                    
                                                    </>
                                                )}
                                                {/* <InfoCard title="켜는 시간" value={monthOnTime || '-'} unit="분" />
                                                <InfoCard title="끄는 시간" value={monthOffTime || '-'} unit="분" /> */}
                                                <InfoCard title="센싱 횟수(24시간)" value={device.sNum ?? '0'} unit="회" />
                                            </div>
                                        </section>
                                        
                                        {/* 2-5. 기타 설정 및 위치 정보 (별도 컴포넌트로 분리 가능) */}
                                        <section className="section-panel setting-location-section">
                                            <h2 className="panel-title">⚙️ 위치 정보</h2>
                                            <div className="location-info-detail">
                                                <p>위도: {devicesDB[fullIndex] ? devicesDB[fullIndex].loc : '-'}</p>
                                                <p>경도: {devicesDB[fullIndex] ? devicesDB[fullIndex].lot : '-'}</p>
                                                <p>기울기 좌(+)우(-): {devicesDB[fullIndex] ? devicesDB[fullIndex].vecx : '0'}</p>
                                                <p>기울기 상(+)하(-): {devicesDB[fullIndex] ? devicesDB[fullIndex].vecy : '0'}</p>
                                            </div>
                                        </section>
    
                                    </div>
                                </div>
    
    
                            // </DeviceStyle.DeviceArea>
                        )
                    })

                ) : (

                    // **********************************
                    // 📜 한 번에 보기 (전체 스크롤 방식) 렌더링
                    // **********************************
                    // mobile_currentDevices 대신 **전체 디바이스 배열 (devices)** 사용
                    displayDevices.map((device, fullIndex) => {
                        const deviceNum = fullIndex + 1;
                        // '한번에 보기'는 단순 텍스트 형태이므로, 새로운 컴포넌트를 사용하거나 인라인 스타일을 적용합니다.
                        return (
                        
                            // <DeviceStyle.DeviceArea key={device.deviceNum} style={{ marginBottom: '20px', padding: '15px', border: '1px solid #eee' }}>
                            <div className="dashboard-mobile-container" key={device.deviceNum} style={{ marginBottom: '20px', padding: '30px', border: '1px solid #eee' }}>
                                <SimpleDeviceInfo 
                                    device={device as DeviceData}
                                    fullIndex={fullIndex}
                                    deviceNum={deviceNum}
                                    selectedGroupName={selectedGroupName}
                                    devicesDB={devicesDB}
                                />
                            </div>
                            // </DeviceStyle.DeviceArea>
                        );
                    })

                )}
                <div style={{ textAlign: 'right', marginBottom: '15px' }}>
                    <button className="btn btn-secondary" onClick={handleApply_Gets} style={{ padding: '8px 15px', cursor: 'pointer', border: '1px solid #ccc', borderRadius: '5px' }}>
                        요청
                    </button>
                </div>
            </DeviceStyle.MainContainer>

            <>
            {/* 👇 모달 컴포넌트 렌더링 */}
            {showConfigModal && (
                <DeviceSetDrawerM
                    isOpen={showConfigModal}
                    onClose={closeModal}
                    currentUser={currentUser}
                    // deviceNum={deviceNum}

                    // setShowConfigModal={setShowConfigModal}
                    deviceNum={selectedDeviceNum} 
                    selectedSiteId={selectedSiteId}
                    selectedGroupId={selectedGroupId}
                    selectedGroupName={selectedGroupName}

                    deviceSettingTab={deviceSettingTab}
                    setDeviceSettingTab={setDeviceSettingTab}

                    // 디바이스 탭 제어 1 탭 설정 값
                    this_brightness={this_brightness}
                    setThisBrightness={setThisBrightness}
                    this_brightnessMode={this_brightnessMode}
                    setThisBrightnessMode={setThisBrightnessMode}

                    // 디바이스 탭 제어 2 탭 설정 값 없음

                    // 디바이스 탭 제어 3 탭 설정 값
                    this_distanceLeft={this_distanceLeft}
                    setThisDistanceLeft={setThisDistanceLeft}
                    this_distanceRight={this_distanceRight}
                    setThisDistanceRight={setThisDistanceRight}
                    this_distanceBottom={this_distanceBottom}
                    setThisDistanceBottom={setThisDistanceBottom}
                    
                    // 디바이스 탭 제어 4 탭 설정 값
                    led_mode={led_mode}
                    setLed_mode={setLed_mode}
                    maxBright={maxBright}
                    setMaxBright={setMaxBright}
                    minBright={minBright}
                    setMinBright={setMinBright}
                    keepOnTime={keepOnTime}
                    setKeepOnTime={setKeepOnTime}
                    sideOnLed={sideOnLed}
                    setSideOnLed={setSideOnLed}
                />
            )}
            </>     

        </MediaQuery>

{/* ////////////////////////////////////////////////////////////////////////////// */}
{/* ////////////////////////////////////////////////////////////////////////////// */}
{/* ////////////////////////////////////////////////////////////////////////////// */}
{/* ////////////////////////////////////////////////////////////////////////////// */}
{/* ////////////////////////////////////////////////////////////////////////////// */}
{/* **************************** 태블릿, 데스트톱 UI ****************************** */}

        <MediaQuery minWidth={768}>
        
            <DeviceStyle.MainContainer>
                <DeviceStyle.TabGridContainer>

                        <DeviceGraphModal
                            show={showGraphModal}
                            onClose={() => setShowGraphModal(false)}
                            selectedGroupName={selectedGroupName}
                            deviceNum={selectedDeviceNum}
                            dailyData={dailyData}
                            weeklyData={weeklyData}
                        />

                    {currentDevices.map((device, index) => {
                    // 현재 3개 중 몇 번째 디바이스인지 계산 (전체 devices 기준 index)
                        // console.log("🧩 Rendering devices:", currentDevices.map(d => d.deviceNum || d.deviceId));
                        // console.log(
                        // "🧩 Rendering devices (check IDs):",
                        // currentDevices.map((d) => ({
                        //     id: d.deviceId,
                        //     num: d.deviceNum,
                        //     LED: d.LEDSts
                        // }))
                        // );                        
                        const fullIndex = startIndex + index;
                        const errorCode = Number(device.errSts);
                        
                        // 디바이스 번호 (1부터 시작)
                        const deviceNum = fullIndex + 1;

                        const errorStatusClass = Number(device.errSts) > 0 ? 'status-error' : 'status-ok';
                        const errorStatusText = Number(device.errSts) > 0 ? '에러 발생' : '정상 작동';                        

                        // devices 배열에서 해당 인덱스의 디바이스가 실제로 존재하는지 확인 (마지막 페이지에서 3개 미만일 수 있음)
                        if (!device) return null; 

                        return (                        
                    
                            <DeviceStyle.DeviceArea key={device.deviceNum}>

                            {/* <DeviceStyle.DeviceArea key={`${device.deviceNum ?? device.deviceId}-${index}`}> */}

                            {/* <DeviceStyle.DeviceArea key={device.deviceNum ?? device.deviceId}> */}

                                <DeviceStyle.DeviceTitle>
                                    <div>
                                        <h5>{selectedGroupName} {deviceNum}</h5>
                                        <p></p>
                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px' }}>
                                            <DeviceStyle.GraphButton
                                                onClick={() => getGraphDatas(deviceNum)}
                                            >
                                                그래프
                                            </DeviceStyle.GraphButton>  
                                            <DeviceStyle.DeviceButton
                                                onClick={() => openConfigModal(deviceNum)}
                                            >
                                                제어/설정
                                            </DeviceStyle.DeviceButton>
                                        </div>
                                    </div>
                                    {/* <DeviceStyle.DeviceTitleText>
                                        {selectedGroupName} {deviceNum}
                                    </DeviceStyle.DeviceTitleText>
                                    <DeviceStyle.GraphButton
                                        // onClick={() => setShowConfigModal(true)}
                                        onClick={() => getGraphDatas(deviceNum)}
                                    >
                                        그래프
                                    </DeviceStyle.GraphButton>
                                    <DeviceStyle.DeviceButton
                                        // onClick={() => setShowConfigModal(true)}
                                        onClick={() => openConfigModal(deviceNum)}
                                    >
                                        제어/설정
                                    </DeviceStyle.DeviceButton>                                     */}

                                </DeviceStyle.DeviceTitle>

                                {/* <DeviceStyle.DeviceInfoTable>

                                    <DeviceStyle.DeviceInfoTableRow>
                                        <DeviceStyle.DeviceInfoTableRowInfoTitle>풍력 누적 발전량 : </DeviceStyle.DeviceInfoTableRowInfoTitle>
                                        <DeviceStyle.DeviceInfoTableRowInfoText>{device.wGen}</DeviceStyle.DeviceInfoTableRowInfoText>
                                    </DeviceStyle.DeviceInfoTableRow>

                                    <DeviceStyle.DeviceInfoTableRow>
                                        <DeviceStyle.DeviceInfoTableRowInfoTitle>풍력 순간 발전량 : </DeviceStyle.DeviceInfoTableRowInfoTitle>
                                        <DeviceStyle.DeviceInfoTableRowInfoText>{device.wPwr}</DeviceStyle.DeviceInfoTableRowInfoText> 
                                    </DeviceStyle.DeviceInfoTableRow>

                                    <DeviceStyle.DeviceInfoTableRow>
                                        <DeviceStyle.DeviceInfoTableRowInfoTitle>태양광 누적 발전량 : </DeviceStyle.DeviceInfoTableRowInfoTitle>
                                        <DeviceStyle.DeviceInfoTableRowInfoText>{device.sGen}</DeviceStyle.DeviceInfoTableRowInfoText>
                                    </DeviceStyle.DeviceInfoTableRow>

                                    <DeviceStyle.DeviceInfoTableRow>
                                        <DeviceStyle.DeviceInfoTableRowInfoTitle>태양광 순간 발전량 : </DeviceStyle.DeviceInfoTableRowInfoTitle>
                                        <DeviceStyle.DeviceInfoTableRowInfoText>{device.sPwr}</DeviceStyle.DeviceInfoTableRowInfoText> 
                                    </DeviceStyle.DeviceInfoTableRow>

                                    <DeviceStyle.DeviceInfoTableRow>
                                        <DeviceStyle.DeviceInfoTableRowInfoTitle>최대 밝기 : </DeviceStyle.DeviceInfoTableRowInfoTitle>
                                        <DeviceStyle.DeviceInfoTableRowInfoText>{devicesDB[fullIndex] ? devicesDB[fullIndex].maxLED : '-'}</DeviceStyle.DeviceInfoTableRowInfoText>
                                    </DeviceStyle.DeviceInfoTableRow>

                                    <DeviceStyle.DeviceInfoTableRow>
                                        <DeviceStyle.DeviceInfoTableRowInfoTitle>최소 밝기 : </DeviceStyle.DeviceInfoTableRowInfoTitle>
                                        <DeviceStyle.DeviceInfoTableRowInfoText>{devicesDB[fullIndex] ? devicesDB[fullIndex].minLED : '-'}</DeviceStyle.DeviceInfoTableRowInfoText>
                                    </DeviceStyle.DeviceInfoTableRow>

                                    <DeviceStyle.DeviceInfoTableRow>
                                        <DeviceStyle.DeviceInfoTableRowInfoTitle>LED 밝기 : </DeviceStyle.DeviceInfoTableRowInfoTitle>
                                        <DeviceStyle.DeviceInfoTableRowInfoText>{device.LEDSts}</DeviceStyle.DeviceInfoTableRowInfoText>
                                    </DeviceStyle.DeviceInfoTableRow>

                                    <DeviceStyle.DeviceInfoTableRow>
                                        <DeviceStyle.DeviceInfoTableRowInfoTitle>에러상태 : </DeviceStyle.DeviceInfoTableRowInfoTitle>
                                        <DeviceStyle.DeviceInfoTableRowInfoText>{device.errSts}</DeviceStyle.DeviceInfoTableRowInfoText> 
                                    </DeviceStyle.DeviceInfoTableRow>

                                    <DeviceStyle.DeviceInfoTableRow>
                                        <DeviceStyle.DeviceInfoTableRowInfoTitle>배터리 전압 : </DeviceStyle.DeviceInfoTableRowInfoTitle>
                                        <DeviceStyle.DeviceInfoTableRowInfoText>{device.batV}</DeviceStyle.DeviceInfoTableRowInfoText>
                                    </DeviceStyle.DeviceInfoTableRow>

                                    <DeviceStyle.DeviceInfoTableRow>
                                        <DeviceStyle.DeviceInfoTableRowInfoTitle>배터리 잔량 : </DeviceStyle.DeviceInfoTableRowInfoTitle>
                                        <DeviceStyle.DeviceInfoTableRowInfoText>{device.batSts}</DeviceStyle.DeviceInfoTableRowInfoText> 
                                    </DeviceStyle.DeviceInfoTableRow>

                                    <DeviceStyle.DeviceInfoTableRow>
                                        <DeviceStyle.DeviceInfoTableRowInfoTitle>온도 : </DeviceStyle.DeviceInfoTableRowInfoTitle>
                                        <DeviceStyle.DeviceInfoTableRowInfoText>{device.temp}</DeviceStyle.DeviceInfoTableRowInfoText> 
                                    </DeviceStyle.DeviceInfoTableRow>

                                    <DeviceStyle.DeviceInfoTableRow>
                                        <DeviceStyle.DeviceInfoTableRowInfoTitle>습도 : </DeviceStyle.DeviceInfoTableRowInfoTitle>
                                        <DeviceStyle.DeviceInfoTableRowInfoText>{device.hum ?? '-'}</DeviceStyle.DeviceInfoTableRowInfoText>
                                    </DeviceStyle.DeviceInfoTableRow>

                                    <DeviceStyle.DeviceInfoTableRow>
                                        <DeviceStyle.DeviceInfoTableRowInfoTitle>갱신 시간 : </DeviceStyle.DeviceInfoTableRowInfoTitle>
                                        <DeviceStyle.DeviceInfoTableRowInfoText>{device.curT}</DeviceStyle.DeviceInfoTableRowInfoText> 
                                    </DeviceStyle.DeviceInfoTableRow>

                                    <DeviceStyle.DeviceInfoTableRow>
                                        <DeviceStyle.DeviceInfoTableRowInfoTitle>위도 : </DeviceStyle.DeviceInfoTableRowInfoTitle>
                                        <DeviceStyle.DeviceInfoTableRowInfoText>{devicesDB[fullIndex] ? devicesDB[fullIndex].loc : '-'}</DeviceStyle.DeviceInfoTableRowInfoText>
                                        <DeviceStyle.DeviceInfoTableRowInfoTitle>경도 : </DeviceStyle.DeviceInfoTableRowInfoTitle>
                                        <DeviceStyle.DeviceInfoTableRowInfoText>{devicesDB[fullIndex] ? devicesDB[fullIndex].lot : '-'}</DeviceStyle.DeviceInfoTableRowInfoText>
                                    </DeviceStyle.DeviceInfoTableRow>

                                    <DeviceStyle.DeviceInfoTableRow>
                                        <DeviceStyle.DeviceInfoTableRowInfoTitle>펌웨어 버전 : </DeviceStyle.DeviceInfoTableRowInfoTitle>
                                        <DeviceStyle.DeviceInfoTableRowInfoText>{devicesDB[fullIndex] ? devicesDB[fullIndex].fwVer : '-'}</DeviceStyle.DeviceInfoTableRowInfoText>
                                    </DeviceStyle.DeviceInfoTableRow>                                

                                </DeviceStyle.DeviceInfoTable> */}


                                <div className="dashboard-container">
                                    
                                    {/* 1. 헤더: 핵심 상태 요약 및 시간 정보 */}
                                    <header className="dashboard-header">

                                        <div className={`system-status ${errorStatusClass}`}>
                                            <span className="status-dot"></span>
                                            <span className="status-text">{errorStatusText} (Code: {errorCode ?? '-'})</span>
                                        </div>
                                        <div className="time-info">
                                            <p>🕒 {device.curT}</p>
                                            <p>F/W 버전: {devicesDB[fullIndex] ? devicesDB[fullIndex].fwVer : '-'}</p>
                                        </div>
                                    </header>

                                    {/* 2. 메인 그리드: 중요 정보 (발전, 배터리, 환경) */}
                                    <div className="main-grid">

                                        {/* 2-1. 발전량 섹션 (2x2 그리드) */}
                                        <section className="section-panel power-generation-section">
                                            <h2 className="panel-title">⚡ 에너지 정보</h2>
                                            <div className="data-grid two-by-two">
                                                <InfoCard title="풍력 순간 발전" value={device.wPwr ?? '-'} unit="mW" className="highlight-card wind" />
                                                <InfoCard title="풍력 누적 발전" value={device.wGen ?? '-'} unit="Wh" className="highlight-card wind" />
                                                <InfoCard title="태양광 순간 발전" value={device.sPwr ?? '-'} unit="mW" className="highlight-card solar" />
                                                <InfoCard title="태양광 누적 발전" value={device.sGen ?? '-'} unit="Wh" className="highlight-card solar" />
                                                <InfoCard title="LED 순간 소모" value={device.LEDCP ?? '-'} unit="mW" className="highlight-card led" />
                                                <InfoCard title="LED 누적 소모" value={device.LEDPwr ?? '-'} unit="Wh" className="highlight-card led" />                                                
                                            </div>
                                        </section>

                                        {/* 2-2. 배터리 상태 섹션 */}
                                        <section className="section-panel battery-section">
                                            <h2 className="panel-title">🔋 배터리 상태</h2>
                                            <div className="battery-display">
                                                <div className="large-value-display">
                                                    <span className="battery-percent">{device.batSts ?? '-'}</span>
                                                    <span className="percent-unit">%</span>
                                                </div>
                                                {/* CSS로 잔량에 따른 색상 변화 및 진행률 바 구현 */}
                                                <div className="progress-bar-container">
                                                    <div 
                                                        className="battery-progress-bar" 
                                                        style={{ width: `${device.batSts ?? 0}%` }}
                                                    ></div>
                                                </div>
                                                <p className="voltage-info">전압: {device.batV ?? '-'} mV</p>
                                            </div>
                                        </section>

                                        {/* 2-3. LED 상태 섹션 */}
                                        <section className="section-panel battery-section">
                                            <h2 className="panel-title">💡 LED 상태</h2>
                                            <div className="battery-display">
                                                <div className="large-value-display">
                                                    <span className="led-percent">{device.LEDSts ?? '-'}</span>
                                                    <span className="percent-unit">%</span>
                                                </div>
                                                {/* CSS로 잔량에 따른 색상 변화 및 진행률 바 구현 */}
                                                <div className="progress-bar-container">
                                                    <div 
                                                        className="led-progress-bar" 
                                                        style={{ width: `${device.LEDSts ?? 0}%` }}
                                                    ></div>
                                                </div>
                                                <p className="voltage-info">최소 / 최대 밝기: {devicesDB[fullIndex] ? devicesDB[fullIndex].minLED : '-'} / {devicesDB[fullIndex] ? devicesDB[fullIndex].maxLED : '-'}</p>
                                            </div>
                                        </section>

                                        {/* 2-4. 환경 및 설정 섹션 (2x2 그리드) */}
                                        <section className="section-panel environment-section">
                                            <h2 className="panel-title">🗺️ 환경 및 설정</h2>
                                            <div className="data-grid two-by-two">
                                                <InfoCard title="온도" value={device.temp ?? '-'} unit="°C" className="env-card" />
                                                <InfoCard title="습도" value={device.hum ?? '-'} unit="%" className="env-card" />
                                                {/* 조건부 렌더링 적용 부분 */}
                                                {Number(ledModeList[deviceNum - 1]) === 1 ? (
                                                    // getGroupMode가 1일 때 표시되는 UI
                                                    <>
                                                        <InfoCard title="켜는 시간" value={monthOnTime || '-'} unit="" />
                                                        <InfoCard title="끄는 시간" value={monthOffTime || '-'} unit="" />
                                                    </>
                                                ) : (
                                                    // 그 외의 경우(1이 아닐 때) 표시되는 UI
                                                    <>
                                                        <InfoCard title="⏱️켜는 시간" value={onTList[deviceNum - 1] || '-'} unit="" />
                                                        <InfoCard title="⏱️끄는 시간" value={offTList[deviceNum - 1] || '-'} unit="" />                                                    
                                                    </>
                                                )}
                                                {/* <InfoCard title="켜는 시간" value={monthOnTime || '-'} unit="분" />
                                                <InfoCard title="끄는 시간" value={monthOffTime || '-'} unit="분" /> */}
                                                <InfoCard title="센싱 횟수(24시간)" value={device.sNum ?? '0'} unit="회" />
                                            </div>
                                        </section>
                                        
                                        {/* 2-5. 기타 설정 및 위치 정보 (별도 컴포넌트로 분리 가능) */}
                                        <section className="section-panel setting-location-section">
                                            <h2 className="panel-title">⚙️ 위치 정보</h2>
                                            <div className="location-info-detail">
                                                <p>위도: {devicesDB[fullIndex] ? devicesDB[fullIndex].loc : '-'}</p>
                                                <p>경도: {devicesDB[fullIndex] ? devicesDB[fullIndex].lot : '-'}</p>
                                                <p>기울기 좌(+)우(-): {devicesDB[fullIndex] ? devicesDB[fullIndex].vecx : '0'}</p>
                                                <p>기울기 상(+)하(-): {devicesDB[fullIndex] ? devicesDB[fullIndex].vecy : '0'}</p>                                                
                                            </div>
                                        </section>

                                    </div>
                                </div>


                            </DeviceStyle.DeviceArea>
                        )
                    })}

                </DeviceStyle.TabGridContainer>

                {/* 이전/다음 이동 버튼 (3개씩 이동) */}

                <DeviceStyle.DevicePageFrame>
                    
                    {/* 현재 인덱스가 0일 때 이전 버튼 비활성화 */}
                    <DeviceStyle.DevicePageButton
                        onClick={prevDevice} 
                        disabled={displayStartIndex === 0}
                    >
                        {/* <DeviceStyle.DevicePageIcon
                            $imgUrl={DevicePagePreTabletIcon}
                        /> */}
                        &lt; 이전
                    </DeviceStyle.DevicePageButton>
                    
                    <DeviceStyle.DevicePageNumTextFrame>
                    <DeviceStyle.DevicePageNumText>
                        {/* 현재 화면에 보이는 디바이스 범위 */}
                        {totalDeviceCount > 0 ? (
                            <>
                                {/* {currentPage} / {totalPages} */}
                                {displayStartIndex + 1} - {Math.min(displayStartIndex + DEVICES_ON_SCREEN, totalDeviceCount)} <br></br> Total : {totalDeviceCount}
                            </>
                        ) : (
                            "디바이스 없음"
                        )}
                    </DeviceStyle.DevicePageNumText>
                    </DeviceStyle.DevicePageNumTextFrame>
                    
                    {/* 현재 인덱스가 마지막 3개 그룹의 시작점일 때 다음 버튼 비활성화 */}
                    <DeviceStyle.DevicePageButton
                        onClick={nextDevice} 
                        disabled={
                            displayDevices.length === 0 || 
                            displayStartIndex >= maxStartIndex
                        }
                    >
                        다음 &gt;
                        {/* <DeviceStyle.DevicePageIcon
                            $imgUrl={DevicePageNextTabletIcon}
                        />                             */}
                    </DeviceStyle.DevicePageButton>

                </DeviceStyle.DevicePageFrame>          

            </DeviceStyle.MainContainer>

            <>
            {/* 👇 모달 컴포넌트 렌더링 */}
            {showConfigModal && (
                <DeviceSetDrawer
                    isOpen={showConfigModal}
                    onClose={closeModal}
                    currentUser={currentUser}
                    // deviceNum={deviceNum}

                    // setShowConfigModal={setShowConfigModal}
                    deviceNum={selectedDeviceNum} 
                    selectedSiteId={selectedSiteId}
                    selectedGroupId={selectedGroupId}
                    selectedGroupName={selectedGroupName}

                    deviceSettingTab={deviceSettingTab}
                    setDeviceSettingTab={setDeviceSettingTab}

                    // 디바이스 탭 제어 1 탭 설정 값
                    this_brightness={this_brightness}
                    setThisBrightness={setThisBrightness}
                    this_brightnessMode={this_brightnessMode}
                    setThisBrightnessMode={setThisBrightnessMode}

                    // 디바이스 탭 제어 2 탭 설정 값 없음

                    // 디바이스 탭 제어 3 탭 설정 값
                    this_distanceLeft={this_distanceLeft}
                    setThisDistanceLeft={setThisDistanceLeft}
                    this_distanceRight={this_distanceRight}
                    setThisDistanceRight={setThisDistanceRight}
                    this_distanceBottom={this_distanceBottom}
                    setThisDistanceBottom={setThisDistanceBottom}
                    
                    // 디바이스 탭 제어 4 탭 설정 값
                    led_mode={led_mode}
                    setLed_mode={setLed_mode}
                    maxBright={maxBright}
                    setMaxBright={setMaxBright}
                    minBright={minBright}
                    setMinBright={setMinBright}
                    keepOnTime={keepOnTime}
                    setKeepOnTime={setKeepOnTime}
                    sideOnLed={sideOnLed}
                    setSideOnLed={setSideOnLed}
                />
            )}
            </>            

        </MediaQuery>        
        </>
    );
};

export default DeviceSettings;
